import { ISettings } from "./ISettings";

class EnvironmentSettings implements ISettings {
    production = false;
    baseUrl: string = (window as any).ItpNamespace.settings.baseUrl;
}

export const settings = new EnvironmentSettings();
